//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'IndexHead',
  props: {
    right: {
      type: Boolean,
      default: false
    },
    headStyle: {
      type: Object,
      default() {
        return {}
      }
    },
    isBack: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    backToMain() {
      if (this.isBack) {
        this.$emit('back')
      } else {
        webBridge.onBackPressed()
      }
    },
    search() {
      this.$emit('href', this.type)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/indexHead.vue